import React from "react";
import { useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "../../Utils/routes";
import { getAxiosInstance, getConfig } from "../../Utils/apiService";
import { useAppContext } from "../../Helpers/Contexts/appContext";
import KenLoader from "../../GlobalComponents/KenLoader";
import axios from "axios";
import { KEY_AZURE_TOKEN } from "../../Helpers/constant";
import { ConfigOptions } from "../../interfaces/Common";
import AuthLayout from "../../Components/AuthLayout";
import AppLayout from "../../Components/AppLayout";
import { PrivateRoute, PublicRoute } from "../../Utils/helperFunctions";
import RequestService from "../Service/components/Requests/RequestService";
import Answers from "../Service/components/Questions/Answers";
import TicketPreview from "../Service/components/Ticket/TicketPreview";

const OnBoarding = React.lazy(() => import("../OnBoarding/index"));
const Signup = React.lazy(() => import("../Auth/SignUp/index"));
const VerifyOTP = React.lazy(() => import("../Auth/VerifyOtp/index"));
const EmailConformation = React.lazy(() => import("../Auth/ConfirmEmail/index"));
const Login = React.lazy(() => import("../Auth/Login/index"));
const ForgotPassword = React.lazy(() => import("../Auth/ForgotPassword/index"));
const ConfirmPassword = React.lazy(() => import("../Auth/ConfirmPassword/index"));
const Home = React.lazy(() => import("../Home/index"));
const Events = React.lazy(() => import("../Events/index"));
const EventDetails = React.lazy(() => import("../Events/EventDetails/index"));
const HostEvent = React.lazy(() => import("../Events/HostEvent/index"));
const Jobs = React.lazy(() => import("../Jobs/index"));
const JobDetails = React.lazy(() => import("../Jobs/JobDetails/index"));
const PostJob = React.lazy(() => import("../Jobs/PostJob/index"));
const Mentorship = React.lazy(() => import("../Mentorship/index"));
const Groups = React.lazy(() => import("../Groups/index"));
const Alumni = React.lazy(() => import("../Alumni/index"));
const Service = React.lazy(() => import("../Service/index"));

const MainLayout: React.FunctionComponent = () => {
  const {
    dispatch,
    state: { config },
  } = useAppContext();

  useEffect(() => {
    getConfig()
      .then((res: Array<ConfigOptions>) => {
        dispatch({ type: "updateConfig", value: res[0]?.config });
        dispatch({ type: "updateLogo", value: res[0]?.config?.logoURL });
        getAxiosInstance(res);
        try {
          axios({ method: "get", baseURL: res[0]?.config?.tokenUrl })
            .then((response: any) => {
              localStorage.setItem(KEY_AZURE_TOKEN, response.data.access_token);
            })
            .catch((err) => {
              return err;
            });
        } catch (err) {
          console.error(err);
        }
      })
      .catch((err) => {
        console.error("error in config", err);
      });
  }, []);

  return config.apiBaseUrl === "" ? (
    <KenLoader />
  ) : (
    <>
      <Routes>
        {/* Initial Route */}
        <Route path="/" element={<Navigate to={routes.login} />} />

        {/* Public Routes */}
        <Route
          path={routes.login}
          index
          element={
            <PublicRoute>
              <AuthLayout>
                <Login />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.otpverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <VerifyOTP />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.emailverification}
          element={
            <PublicRoute>
              <AuthLayout>
                <EmailConformation />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.forgotPassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ForgotPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.signup}
          element={
            <PublicRoute>
              <AuthLayout>
                <Signup />
              </AuthLayout>
            </PublicRoute>
          }
        />
        <Route
          path={routes.changePassword}
          element={
            <PublicRoute>
              <AuthLayout>
                <ConfirmPassword />
              </AuthLayout>
            </PublicRoute>
          }
        />

        {/* Private Routes */}
        <Route
          path={routes.onboarding}
          element={
            <PrivateRoute>
              <OnBoarding />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <AppLayout>
                <Home />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Events */}
        <Route
          path={routes.events}
          element={
            <PrivateRoute>
              <AppLayout>
                <Events />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.eventDetail}/:eventId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <EventDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.hostEvent}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <HostEvent />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Jobs */}

        <Route
          path={`${routes.jobs}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Jobs />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.jobDetails}/:jobId`}
          element={
            <PrivateRoute>
              <AppLayout>
                <JobDetails />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.postJob}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <PostJob />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* MentorShip */}

        <Route
          path={`${routes.mentorship}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Mentorship />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Groups */}

        <Route
          path={`${routes.groups}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Groups />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Alumni */}

        <Route
          path={`${routes.alumni}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Alumni />
              </AppLayout>
            </PrivateRoute>
          }
        />

        {/* Service and Support */}

        <Route
          path={`${routes.service}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Service />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.RequestService}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <RequestService />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.Answers}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <Answers />
              </AppLayout>
            </PrivateRoute>
          }
        />
        <Route
          path={`${routes.TicketPreview}`}
          element={
            <PrivateRoute>
              <AppLayout>
                <TicketPreview />
              </AppLayout>
            </PrivateRoute>
          }
        />
      </Routes>
    </>
  );
};

export default MainLayout;
